import React from 'react';
import { gs } from '../../styles/globalStyles';
import { Loader } from './Button';

interface Column<T> {
  key: keyof T | string;
  label: string;
  render?: (row: T, idx: number) => React.ReactNode;
  className?: string;
}

interface TableProps<T> {
  columns: Column<T>[];
  data: T[];
  loading?: boolean;
  emptyMessage?: string;
  keyExtractor?: (row: T, idx: number) => string | number;
}

export function Table<T extends object>({
  columns, data, loading, emptyMessage = 'No data found.',
  keyExtractor,
}: TableProps<T>) {
  return (
    <div className={gs.tableWrapper}>
      <table className={gs.table}>
        <thead className={gs.thead}>
          <tr>
            {columns.map(col => (
              <th key={String(col.key)} className={`${gs.th} ${col.className || ''}`}>
                {col.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan={columns.length} className="py-12 text-center">
                <div className="flex justify-center">
                  <Loader />
                </div>
              </td>
            </tr>
          ) : data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="py-12 text-center text-gray-500 text-sm">
                {emptyMessage}
              </td>
            </tr>
          ) : (
            data.map((row, idx) => (
              <tr key={keyExtractor ? keyExtractor(row, idx) : idx} className={gs.tr}>
                {columns.map(col => (
                  <td key={String(col.key)} className={`${gs.td} ${col.className || ''}`}>
                    {col.render
                      ? col.render(row, idx)
                      : String((row as any)[col.key] ?? '—')}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
